import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const MultiselectDropdownUiOptionsSchema = z.object({
  items: z.array(z.string()).optional(),
});

// Transforms the Zod schema to a TypeScript type
export type MultiselectDropdownUiOptions = z.infer<
  typeof MultiselectDropdownUiOptionsSchema
>;

/* The field schema for the MultiSelectDropdown field extension */
export const MultiselectDropdownFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('MultiselectDropdown'),
  MultiselectDropdownUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type MultiselectDropdownProps =
  typeof MultiselectDropdownFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const MultiselectDropdownSchema = MultiselectDropdownFieldSchema.schema;
